import PropTypes from 'prop-types';
import Button from 'components/UI/Button';
import Input from 'components/UI/Input';
import RadioButton from 'components/UI/Radiobutton';
import useLiterals from 'utils/hooks/useLiterals';
import {
  NOTIFICATION_CATEGORIES,
  NOTIFICATION_SEARCH_MAX,
} from 'modules/notifications/categories';

const NotificationFilters = ({
  pending,
  onSearchChange,
  onCategoryChange,
  onApply,
  onClear,
}) => {
  const literals = useLiterals('notifications');
  const options = NOTIFICATION_CATEGORIES.map((item) => ({
    value: item.value,
    label: literals[item.literal],
  }));

  return (
    <div>
      <Input
        name='notification-search'
        placeholder={literals.searchPlaceholder}
        aria-label={literals.searchPlaceholder}
        value={pending.search}
        maxLength={NOTIFICATION_SEARCH_MAX}
        onChange={onSearchChange}
      />
      <div className='mt-6'>
        <RadioButton
          label={literals.category}
          value={pending.category}
          options={options}
          onChange={onCategoryChange}
        />
      </div>
      <Button
        text={literals.search}
        onClick={onApply}
        className='mt-6'
        fullWidth
      />
      <Button
        type='outline-primary'
        text={literals.clearFilters}
        onClick={onClear}
        className='mt-4'
        fullWidth
      />
    </div>
  );
};

NotificationFilters.propTypes = {
  pending: PropTypes.shape({
    search: PropTypes.string,
    category: PropTypes.string,
  }).isRequired,
  onSearchChange: PropTypes.func.isRequired,
  onCategoryChange: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
};

export default NotificationFilters;
